import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { FilingTable } from './components/FilingTable';
import { WebSocketStatus } from './components/WebSocketStatus';
import { useWebSocket } from './hooks/useWebSocket';

const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || '';

if (!WEBSOCKET_URL) {
  throw new Error('WebSocket URL not configured in environment variables');
}

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 3,
      px: 2,
      mt: 'auto',
      backgroundColor: 'transparent',
      textAlign: 'center',
      color: 'text.secondary',
    }}
  >
    {/* TODO: don't hardcode the email address, read from env var or database or something else */}
    <Typography variant="body2">
      Contact us: <a href="mailto:help@filingpulse.com" style={{ color: 'inherit' }}>help@filingpulse.com</a>
    </Typography>
  </Box>
);

function App() {
  const { filings, isConnected, error } = useWebSocket(WEBSOCKET_URL);

  return (
    <Container maxWidth="xl" sx={{
      py: 4,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <WebSocketStatus isConnected={isConnected} error={error} />
      <Typography variant="h4" component="h1" gutterBottom>
        SEC Filings Live Feed
      </Typography>
      <Paper elevation={3} sx={{ flex: 1 }}>
        <FilingTable filings={filings} />
      </Paper>
      <Footer />
    </Container>
  );
}

export default App;
